document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.mobile-menu-toggle');
  var drawer = document.querySelector('.mobile-menu-drawer');
  var closers = document.querySelectorAll('[data-menu-close]');

  function openMenu() {
    if (!drawer || !toggle) return;
    document.body.classList.add('menu-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    if (!drawer || !toggle) return;
    document.body.classList.remove('menu-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle) toggle.addEventListener('click', openMenu);
  closers.forEach(function (el) { el.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
});


// LOSTSHDWS RETAIL V18 — floating mobile header + hero-only scrolling banner.
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.site-header');
  var hero = document.querySelector('.template-index .hero');
  var marquee = document.querySelector('[data-hero-marquee]');
  if (!header || !hero) return;

  if (marquee && window.getComputedStyle(marquee).display !== 'none') {
    document.body.classList.add('has-hero-marquee');
  }

  function updateFloatingHeader() {
    var mobile = window.matchMedia('(max-width: 700px)').matches;
    var heroBottom = hero.offsetTop + hero.offsetHeight;

    if (mobile) {
      var headerThreshold = Math.max(0, heroBottom - header.offsetHeight - 8);
      header.classList.toggle('header--solid', window.scrollY >= headerThreshold);
    } else {
      var desktopHeaderThreshold = Math.max(0, heroBottom - header.offsetHeight);
      header.classList.toggle('header--solid', window.scrollY >= desktopHeaderThreshold);
    }

    if (marquee) {
      var visibleMarquee = window.getComputedStyle(marquee).display !== 'none';
      document.body.classList.toggle('has-hero-marquee', visibleMarquee);
      document.body.classList.toggle('hero-marquee-past', visibleMarquee && window.scrollY >= heroBottom - 1);
    }
  }

  updateFloatingHeader();
  window.addEventListener('scroll', updateFloatingHeader, { passive: true });
  window.addEventListener('resize', updateFloatingHeader);
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', updateFloatingHeader);
    document.addEventListener('shopify:section:select', updateFloatingHeader);
  }
});

// LOSTSHDWS RETAIL V4 — persistent light / dark mode.
document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.mobile-theme-toggle, .desktop-theme-toggle');
  if (!toggles.length) return;

  var storageKey = 'lostshdws-theme';
  var savedTheme = null;
  try { savedTheme = localStorage.getItem(storageKey); } catch (e) {}

  if (savedTheme === 'dark') document.body.classList.add('dark-mode');

  function syncThemeToggles() {
    var isDark = document.body.classList.contains('dark-mode');
    toggles.forEach(function (toggle) {
      toggle.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      toggle.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
    });
  }

  syncThemeToggles();

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var isDark = document.body.classList.toggle('dark-mode');
      try { localStorage.setItem(storageKey, isDark ? 'dark' : 'light'); } catch (e) {}
      syncThemeToggles();
    });
  });
});


// LOSTSHDWS RETAIL V5 — mobile navigation accordion from Shopify menu nesting.
document.addEventListener('DOMContentLoaded', function () {
  var toggles = document.querySelectorAll('.mobile-submenu-toggle');
  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var item = toggle.closest('.mobile-menu-item--parent');
      var submenu = item ? item.querySelector('.mobile-submenu') : null;
      if (!item || !submenu) return;

      var opening = !item.classList.contains('is-open');
      item.classList.toggle('is-open', opening);
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      submenu.hidden = !opening;
    });
  });
});
